import * as PIXI from "pixi.js"
import * as _ from "lodash";
import R from "../config/R";
import * as Events from '../Events'

export default class QuestionController{
  constructor(levelSetting) {
    this.level = levelSetting.level
    this.questions = []
    this.totalCorrect = 0;
  }

  prepareQuestions(){
    // select 12 questions randomly
    this.questions = _.shuffle(R.question[this.level]).slice(0, R.settings.common.totalQuestions)
  }

  isCorrect(selectedChoice, answer) {
    if (selectedChoice === answer) this.totalCorrect = this.totalCorrect + 1
    return selectedChoice === answer
    // this.totalCorrect = this.totalCorrect + 1
    // return true
  }

  isMeetCheckPoint(){
    const isMeetCP = this.totalCorrect !== 0 && this.totalCorrect % 3 === 0
    if(isMeetCP){
      Events.hub.publishEvent(Events.MEET_CHECKPOINT)
      this.totalCorrect = 0
    }
    return isMeetCP
  }

}



// WEBPACK FOOTER //
// ./src/game/controllers/QuestionController.js